// extracted by mini-css-extract-plugin
export default {"mainDiv":"EmailAccCreatedPopup_mainDiv__xgCVp","container":"EmailAccCreatedPopup_container__I9vbI","button":"EmailAccCreatedPopup_button__7KZr0"};